<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Type Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${sample_type.name}`">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit sample type'">
      <template #gated-content>
        <sample-type-form :sample_type="sample_type" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleTypeForm from "@/components/lab/sampletype/SampleTypeForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleTypeNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

const SampleTypeRepository = LabRepositoryFactory.get("sampleType");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleTypeEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleTypeForm,
  },
  data() {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/sampletypes",
            title: "Sample type list",
          },
          {
            icon: "fa-eye",
            linkto: `/sampletypes/${this.sample_type_id}`,
            title: "View sample type",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await SampleTypeRepository.update(this.sample_type_id, form_data);

        this.editSuccess();
        this.$router.push(`/sampletypes/${this.sample_type_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.sample_type = await getModel({
      model_type: "sample_type",
      id: this.sample_type_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: sampleTypeNotifications,
};
</script>
